import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function editFailure(draft: Draft<IAuthData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
